module.exports = __webpack_public_path__ + "img/trash.c8cd637a.svg";